// @flow
import PageDecEvent from '../components/PageDecEvent';

export default PageDecEvent;



// WEBPACK FOOTER //
// ./src/pages/dec-event.jsx